import React, { useState } from "react";
import {
  Mail,
  Globe,
  Send,
  ShieldCheck,
  Clock,
} from "lucide-react";

import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ContactPortal = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);


  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await addDoc(collection(db, "contacts"), {
        ...form,
        createdAt: serverTimestamp(),
      });

      setSuccess(true);

      setForm({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };


  return (
    <section
      id="contact"
      className="py-24 md:py-32 px-6 bg-white border-b-[20px] border-slate-950"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16">

        {/* LEFT */}

        <div>

          <span className="text-orange-600 text-xs font-bold uppercase tracking-widest">
            Global Contact
          </span>

          <h2 className="text-5xl font-black mt-2">
            Contact Focus NDT Group
          </h2>

          <p className="text-slate-500 mt-4 max-w-md">
            For inspection services, NDT projects, shutdown support,
            software solutions, or technical partnerships,
            contact our headquarters.
          </p>


          <div className="mt-10 space-y-6">

            <div className="flex gap-4">
              <Mail />
              <div>
                <p className="text-xs text-slate-400">
                  Email
                </p>
                <p className="font-bold">
                  focusndtgroup@gmail.com
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <Globe />
              <div>
                <p className="text-xs text-slate-400">
                  Operations
                </p>
                <p className="font-bold">
                  India • Offshore • Global
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <Clock />
              <div>
                <p className="text-xs text-slate-400">
                  Response Time
                </p>
                <p className="font-bold">
                  Within 24 hours
                </p>
              </div>
            </div>

          </div>

        </div>



        {/* FORM */}

        <div className="bg-white border p-6 shadow">

          <h3 className="font-bold text-xl mb-4">
            Send Inquiry
          </h3>


          {success && (
            <p className="text-green-600 mb-4">
              Message sent successfully
            </p>
          )}


          <form onSubmit={handleSubmit} className="space-y-4">

            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Full Name"
              className="w-full p-3 border"
              required
            />

            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email"
              className="w-full p-3 border"
              required
            />

            <input
              name="subject"
              value={form.subject}
              onChange={handleChange}
              placeholder="Subject"
              className="w-full p-3 border"
            />

            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              placeholder="Message"
              className="w-full p-3 border"
              rows={4}
            />

            <button
              disabled={loading}
              className="w-full bg-slate-900 text-white p-3"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>

          </form>

        </div>

      </div>
    </section>
  );
};

export default ContactPortal;